import { request } from '@/utils/request'
import { toDictionary } from '@/utils/array'

export function unpack(content) {
    const executives = toDictionary(content.executives || [], e => e.id)
    const companies = toDictionary(content.companies || [], c => c.id)
    const reports = content.reports ?? content.results ?? []

    reports.forEach(r => {
        r.executive = executives[r.executiveId] ?? null
        r.company = companies[r.companyId] ?? null
    })

    return reports
}

async function listReports() {
    const content = await request.get('/api/ceo-change-reports')

    if (!content) {
        return []
    }

    return unpack(content)
}

const CeoChangeReportService = {
    async get(id) {
        const content = await request.get(`/api/ceo-change-reports/${id}`)

        if (!content) {
            return null
        }

        if (content.report) {
            return {
                ...content.report,
                executive: content.executive,
                company: content.company,
            }
        }

        return unpack(content)[0]
    },
    list: listReports,
    async listInProcess() {
        const content = await request.get('/api/ceo-change-reports/in-process')

        if (!content) {
            return []
        }

        return unpack(content)
    },
    unpack,
}

export { CeoChangeReportService }

/* screener */
import { asyncComputed } from '@/utils/asyncComputed.js'
import { debounce } from 'debounce'
import { computed, ref, watch, watchEffect } from 'vue'
import { packCriteria } from '@/utils/filters'

const PAGE_SIZE = 20

async function reportsSearch(criteria, page, sort, facets, signal) {
    const { content } = await request.post(
        '/api/premium-research/search',
        {
            criteria: packCriteria(criteria),
            facets,
            ...page,
            sortField: sort?.field ?? null,
            sortDirection: sort?.direction ?? null,
        },
        { signal }
    )

    content.results = unpack(content)

    return content
}

import { createScreener } from '@/utils/screener.js'

export function createReportsScreener(options = {}) {
    return createScreener(reportsSearch, 'results', options)
}

export async function pipelineSearch(criteria, page, sort, facets, signal) {
    const { content } = await request.post(
        '/api/premium-research/in-process/search',
        {
            criteria: packCriteria(criteria),
            facets,
            ...page,
            sortField: sort?.field ?? null,
            sortDirection: sort?.direction ?? null,
        },
        { signal }
    )

    content.results = unpack(content)

    return content
}

export function createPipelineScreener(options = {}) {
    return createScreener(pipelineSearch, 'results', options)
}
